('use client');

import styled from 'styled-components';

export namespace FallbackModalStyle {
  export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    overflow: auto;
    max-height: calc(100vh - 92px);
    width: calc(100% + 32px);
    margin-left: -16px;
    padding: 10px;
  `;

  export const Header = styled.div`
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    gap: 15px;

    & > svg {
      cursor: pointer;
    }
  `;

  export const Title = styled.h1`
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 20px;
    color: #000000;
  `;

  export const Paragrah = styled.p`
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    color: gray;
    padding: 10px;
  `;
}
